export const utils = {
    config:{
        REACT_APP_API_HOST: process.env.REACT_APP_API_HOST ||  "https://aiapi.agentruntime.cloud"   
    }
}